import { nanoid } from 'nanoid';
import { useQueryState } from 'nuqs';

import { queryParam, queryStateParser } from './queryStateParser';

const QS_TYPE = 'eSignatureRequest' as const;

export const useOpenESignatureRequestPane = (): ((args: { eSignatureRequestId: string }) => void) => {
  const [__, setState] = useQueryState(queryParam, queryStateParser);

  return ({ eSignatureRequestId }) => {
    setState((prevState) => [
      ...(prevState || []),
      {
        id: eSignatureRequestId,
        key: nanoid(),
        type: QS_TYPE,
      },
    ]);
  };
};
